import { createActionCreator, paramsEncode } from '../../../utils/';
import request from '../../../utils/request';
import constant from './constant';
import Urls from '../../../../config/index';

export const createLoadingAction = createActionCreator(constant.loading, loading => loading);
export const createStatisticsListAction = createActionCreator(constant.statisticList, list => list);
export const createSearchAction = createActionCreator(constant.search, o => o);
export const createAgentsAction = createActionCreator(constant.agents, list => list);
export const createAreasAction = createActionCreator(constant.areas, list => list);
export const createStatisticsTotalAction = createActionCreator(constant.statisticTotal, list => list);

let taskStatisticUrl = Urls.TaskStatisticUrl;
let partnerUrl = Urls.PartnerUrl;

// 获取合作、地区列表
export const getAgentsAndAreas = () => {
    return async (dispatch, getState) => {
        try {
            let response = await request(partnerUrl.paramList);
            dispatch(createAgentsAction(response.partnerName));
            dispatch(createAreasAction(response.area));
        } catch (e) {
            throw new Error(e);
        }
    }
}


//获取数据统计（表格数据）
export const getStatisticTotal = () => {
    return async (dispatch, getState) => {
        try {
            dispatch(createLoadingAction(true));
            let search = getState().taskStatistic.search;
            let response = await request(taskStatisticUrl.total + paramsEncode(Object.assign({}, search, { beginTimeView: '' }, { endTimeView: '' })));
            dispatch(createStatisticsTotalAction(response));
        } catch (e) {
            throw new Error(e);
        } finally {
            dispatch(createLoadingAction(false));
        }
    }
}


//获取数据统计列表接口(图标数据)
export const getStatisticList = () => {
    return async (dispatch, getState) => {
        try {
            let search = getState().taskStatistic.search;
            let response = await request(taskStatisticUrl.list + paramsEncode(Object.assign({}, search, { beginTimeView: '' }, { endTimeView: '' })));
            dispatch(createStatisticsListAction(response));
        } catch (e) {
            throw new Error(e);
        }
    }
}

//
export const onFieldsChange = (search) => {
    return (dispatch, getState) => {
        dispatch(createSearchAction(search));
    }
}



// WEBPACK FOOTER //
// ./pages/StatisticalAnalysis/task-statistics/action.js